/**
 * game.js
 *
 * Core game configuration constants.
 * Extracted from App.js lines 114–116.
 */

export const GRID_WIDTH  = 5;
export const GRID_HEIGHT = 6;
export const MAX_LIVES   = 3;